import { SetStateAction, Dispatch } from 'react';
import { useDispatch } from 'react-redux';
import { MessageModal } from 'common/components';
import {
    EXPORT_POPUP_ERROR_MESSAGE,
    EXPORT_POPUP_MESSAGE,
    EXPORT_POPUP_TITLE,
    EXPORT_SUCCESS,
    FAILURE_HEADER,
    SUCCESS_HEADER
} from 'common/config/message.config';
import { ButtonLabel, MessageType } from 'common/enums';
import { appStateActions } from 'common/redux/app-state';

import { ExportRequestDto } from 'modules/master-data/models/export.model';
import { MasterDataService } from 'modules/master-data/redux/masterData.service';

type EntityExportProps = {
    data?: ExportRequestDto;
    isConfirmationVisible: boolean;
    setIsConfirmationVisible: Dispatch<SetStateAction<boolean>>;
    onClose: Dispatch<SetStateAction<boolean>>;
};

export default function EntityExport({
    data,
    isConfirmationVisible,
    setIsConfirmationVisible,
    onClose
}: EntityExportProps) {
    const dispatch = useDispatch();

    const handleConfirmation = async (): Promise<void> => {
        if (data) {
            try {
                setIsConfirmationVisible(false);
                dispatch({
                    type: appStateActions.showLoader.type,
                    payload: true
                });
                const response = await MasterDataService.exportData(data);
                if (response && response?.hasErrors && response?.errors) {
                    dispatch({
                        type: appStateActions.showLoader.type,
                        payload: false
                    });
                    dispatch({
                        type: appStateActions.showMessageModal.type,
                        payload: {
                            isVisible: true,
                            header: FAILURE_HEADER,
                            message: EXPORT_POPUP_ERROR_MESSAGE,
                            type: MessageType.Error
                        }
                    });
                } else {
                    if (response && response?.value) {
                        setIsConfirmationVisible(false);
                        exportToCSV(response);
                        dispatch({
                            type: appStateActions.showLoader.type,
                            payload: false
                        });
                        dispatch({
                            type: appStateActions.showMessageModal.type,
                            payload: {
                                isVisible: true,
                                header: SUCCESS_HEADER,
                                message: EXPORT_SUCCESS,
                                type: MessageType.Success
                            }
                        });
                    }
                }
            } catch (error) {
                console.error('Error exporting data:', error);

                dispatch({
                    type: appStateActions.showLoader.type,
                    payload: false
                });

                dispatch({
                    type: appStateActions.showMessageModal.type,
                    payload: {
                        isVisible: true,
                        header: FAILURE_HEADER,
                        message: EXPORT_POPUP_ERROR_MESSAGE,
                        type: MessageType.Error
                    }
                });
            }
        }
    };

    const exportToCSV = (response: any) => {
        const url = response.value.sasUrl;
        const link = document.createElement('a');
        //link.target = '_blank';
        link.href = url;
        link.click();
    };

    const handleConfirmationClose = (): void => {
        onClose(false);
    };

    return (
        <>
            {isConfirmationVisible && (
                <MessageModal
                    headerName={EXPORT_POPUP_TITLE}
                    message={EXPORT_POPUP_MESSAGE}
                    isVisible={isConfirmationVisible}
                    isSecondaryButtonVisible={true}
                    primaryButton={ButtonLabel.Ok}
                    secondaryButton={ButtonLabel.Cancel}
                    onPrimaryAction={handleConfirmation}
                    onSecondaryAction={handleConfirmationClose}
                />
            )}
        </>
    );
}
